import styled from 'styled-components';
import { spacing, fontSizes, fontWeights, colors } from 'ui/theme';
import { Checkmark } from 'ui/icons';

const Container = styled.div`
  align-items: baseline;
  display: flex;
  gap: ${spacing.double};
  justify-content: center;
`;

const Step = styled.div<{
  isActive: boolean;
  isFirstItem: boolean;
  isLastItem: boolean;
}>`
  align-items: center;
  color: ${({ isActive }) => (isActive ? colors.green100 : colors.grey50)};
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  line-height: 1;
  position: relative;
  text-align: center;
  span {
    font-size: ${fontSizes.s12};
    width: min-content;
  }
  &:after {
    background-color: ${colors.grey50};
    content: '';
    height: ${spacing.eighth};
    left: ${({ isFirstItem }) => (isFirstItem ? '90%' : 'unset')};
    position: absolute;
    right: ${({ isLastItem }) => (isLastItem ? '90%' : 'unset')};
    top: ${spacing.base};
    width: 125%;
    z-index: 0;
  }
`;

const StepCounter = styled.div<{ isComplete: boolean }>`
  align-items: center;
  background: white;
  border-radius: 50%;
  border: ${spacing.single} solid currentcolor;
  color: ${({ isComplete }) => (isComplete ? colors.green100 : 'inherit')};
  display: flex;
  font-size: ${fontSizes.s15};
  font-weight: ${fontWeights.bold};
  height: ${spacing.double};
  justify-content: center;
  line-height: ${fontSizes.s12};
  width: ${spacing.double};
  z-index: 1;
`;

type Props = {
  currentStep: number;
  steps: Array<{ label: string }>;
};

export const ProgressBar = ({ currentStep, steps }: Props) => {
  return (
    <Container data-test="catalog-form-step-bar">
      {steps.map((step, i) => {
        const stepCounter = i + 1;
        const isComplete = stepCounter < currentStep;
        return (
          <Step
            key={step.label}
            isFirstItem={i === 0}
            isLastItem={i === steps.length - 1}
            isActive={stepCounter === currentStep}
          >
            <StepCounter isComplete={isComplete}>
              {isComplete ? (
                <Checkmark data-test="completed-step-checkmark" height={10} isColorInherited />
              ) : (
                stepCounter
              )}
            </StepCounter>
            <span>{step.label}</span>
          </Step>
        );
      })}
    </Container>
  );
};
